export default class ChartDataStruct {
  constructor(obj) {
    obj = obj || {};
    this.y = obj.y;
    this.name = obj.name;
    this.data = obj.data;
  }
}
